import { Hammer } from "lucide-react";

import { DevelopmentRow } from "@/components/development/DevelopmentRow";
import { PageHeading } from "@/components/ui/PageHeading";
import { PlaceholderState } from "@/components/ui/PlaceholderState";
import {
  DEVELOPMENT_PROJECT_LABELS,
  DEVELOPMENT_PROJECT_SLUGS,
  type DevelopmentProjectSlug,
} from "@/config/constants";
import type { DevelopmentProject } from "@/data/types";
import {
  useDevelopmentProjects,
  useDevelopmentUpdates,
} from "@/hooks/useDevelopmentProjects";

const FALLBACK: DevelopmentProject[] = DEVELOPMENT_PROJECT_SLUGS.map((slug, i) => ({
  slug,
  title: DEVELOPMENT_PROJECT_LABELS[slug],
  status: "planned",
  order: i,
}));

function ProjectItem({ project }: { project: DevelopmentProject }) {
  const updates = useDevelopmentUpdates(project.slug as DevelopmentProjectSlug);
  return <DevelopmentRow project={project} latestUpdate={updates[0]} />;
}

export function DevelopmentPage() {
  const projects = useDevelopmentProjects();
  const display = projects.length > 0 ? projects : FALLBACK;
  const usingFallback = projects.length === 0;

  return (
    <div>
      <PageHeading
        eyebrow="Tarteeb"
        title="Masjid Development"
        subtitle="Ongoing and planned work for Jama Masjid Dariyapur."
      />

      {usingFallback ? (
        <PlaceholderState
          icon={<Hammer size={28} strokeWidth={1.5} />}
          title="Planning under discussion"
          message="Budget planning and updates will be published soon. The committee is reviewing each item below."
          className="mb-4"
        />
      ) : null}

      <div className="space-y-3 pb-8">
        {display.map((p) =>
          usingFallback ? (
            <DevelopmentRow key={p.slug} project={p} />
          ) : (
            <ProjectItem key={p.slug} project={p} />
          ),
        )}
      </div>
    </div>
  );
}
